export const sidebarMenuItems = {
	dashboard: {
		en: 'Dashboard',
		th: 'แดชบอร์ด',
	},
	oem: {
		en: 'OEM Transaction',
		th: 'รายการคำสั่งผลิตสินค้า',
	},
	marketplace: {
		en: 'Marketplace',
		th: 'รายการคำสั่งซื้อสินค้าทั่วไป',
	},
	production: {
		en: 'Product production info.',
		th: 'ข้อมูลการรับผลิตสินค้า',
	},
	retail: {
		en: 'Retail Products',
		th: 'สินค้าสำหรับจำหน่าย',
	},
	document: {
		en: 'Document',
		th: 'เอกสาร',
	},
	billing: {
		en: 'Billing',
		th: 'การเงิน',
	},
	support: {
		en: 'Support',
		th: 'การช่วยเหลือ',
	},
	profile: {
		en: 'Profile',
		th: 'บัญชีของฉัน',
	},
}

export const menuItems = [
	{
		name: 'for-buyers',
		label: 'For Buyers',
		megamenu: true,
		col: 12,
		col1: [
			// {
			// 	name: 'customer-stories',
			// 	image: '/media/kumopack-navbar/stars-02.svg',
			// 	label: 'Customer stories',
			// 	description: 'Learn how our customers are making big changes.',
			// },
			{
				name: 'https://kumopack.com/pricing/buyer',
				image: '/media/kumopack-navbar/currency-dollar-circle.svg',
				label: "Buyer's Pricing",
				description: "Buyer's pricing plans and features.",
			},
		],
		col2: [],
		col3: [],
	},

	{
		name: 'for-suppliers',
		label: 'For Suppliers',
		megamenu: true,
		col: 12,
		col1: [
			{
				name: 'https://kumopack.com/blogs?page=1&category=partner-success',
				image: '/media/kumopack-navbar/stars-02.svg',
				label: 'Supplier stories',
				description: 'Learn how our suppliers are making big changes.',
			},
			{
				name: 'https://kumopack.com/pricing/supplier',
				image: '/media/kumopack-navbar/currency-dollar-circle.svg',
				label: "Supplier's Pricing",
				description: 'Supplier pricing plans and features.',
			},
		],
		col2: [],
		col3: [],
	},
	{
		name: 'more',
		label: 'More',
		megamenu: true,
		col: 12,
		col1: [
			{
				name: 'https://kumopack.com/materials',
				image: '/media/kumopack-navbar/data.svg',
				label: 'Materials',
				description: 'Get the latest materials and resources.',
			},
			{
				name: 'https://kumopack.com/products',
				image: '/media/kumopack-navbar/package-check.svg',
				label: 'Products',
				description: 'Find the latest products and services.',
			},
		],

		col2: [
			{
				name: 'https://kumopack.com/blogs',
				image: '/media/kumopack-navbar/book-closed.svg',
				label: 'Blog',
				description: 'The latest industry news, updates and info.',
			},
		],

		col3: [
			// {
			// 	name: 'sustainability',
			// 	image: '/media/kumopack-navbar/flag-06.svg',
			// 	label: 'Sustainability',
			// 	description: 'Learn about our story and our mission statement.',
			// },
			// {
			// 	name: 'certifications',
			// 	image: '/media/kumopack-navbar/message-circle-01.svg',
			// 	label: 'Certification',
			// 	description: 'News and writings, press releases, and press resources.',
			// },
		],
	},
]

export default menuItems
